import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

function ProfessionalCard(props) {
  const { link, icon, text, id, active } = props
  return (
    <div className="col-6 col-md-3 pl-0 pr-0">
      <Link
        activeClassName="ProfessionalCard-link visited"
        state={{ id: id, name: text }}
        to={link}
        className={`ProfessionalCard-link ${active ? "visited" : ""}`}
      >
        {text}
        <i className={icon}></i>
      </Link>
    </div>
  )
}

ProfessionalCard.propTypes = {
  link: PropTypes.string,
  id: PropTypes.number,
  icon: PropTypes.string,
  active: PropTypes.bool,
  text: PropTypes.string.isRequired,
}

export default ProfessionalCard
